import { FC } from 'react'

type Props = {
  fill?: string
  className?: string
}

export const ArrowRightIcon: FC<Props> = ({ fill = '#060725', className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 7 6" fill={fill} className={className}>
      <path d="M7 3L3.09968e-07 6L2.33333 3.00001L-4.76837e-07 9.17939e-07L7 3Z" />
    </svg>
  )
}
